import NativeStorage from "@/utils/nativeStorage/native_storage";
import { PRESISITE_INS_HEADER } from "@/utils/nativeStorage/local_keys";
class IgSetHeaders {
  private headersModule: any = null;

  public updateUserHeaders(value: Record<string, string>, userId: string) {
    console.log("updateUserHeaders headers", value, "userId", userId);
    const headers = this.headersModule[userId] || {};
    const newHeaders = { ...headers, ...value };
    this.headersModule[userId] = newHeaders;
    console.log("updateUserHeaders this.headersModule", this.headersModule);
    NativeStorage.set(PRESISITE_INS_HEADER, this.headersModule);
  }

  public async getUserHeaders(user_id: string = "") {
    const userId = user_id ? "" + user_id : "unkown";
    await this.initHeaders();
    const getHeaders =
      this.headersModule[userId] || this.headersModule.unkown || {};
    console.log(
      "this. getHeaders",
      this.headersModule[userId],
      "this.headersModule",
      this.headersModule
    );
    return getHeaders;
  }

  private async initHeaders() {
    if (!this.headersModule) {
      this.headersModule =
        (await NativeStorage.get(PRESISITE_INS_HEADER)) || {};
    }
    console.log("this.headersModule", this.headersModule);
  }
}

export default new IgSetHeaders();
